import React from "react";
import { Toggle, ToggleProps } from "@ui-kitten/components";

const Switch: React.FC<ToggleProps> = ({ onChange, checked, ...rest }) => {
  return (
    <Toggle
      onChange={onChange}
      checked={checked}
      {...rest}
      style={[rest.style]}
    />
  );
};

export default Switch;
